import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SseService } from "./SseService";

@Injectable({
    providedIn: 'root',
})

export class WatchlistService {

    constructor(private _sseservice: SseService) { }

    getWatchlist(token: any): Observable<any> {
        return this._sseservice.apiPostNew('watchlist/symbolsByUserId', {}, token);
    }

    addSymbol(simbolo: string, token: any): Observable<any> {
        return this._sseservice.apiPostNew('watchlist/symbols', { simbolo }, token);
    }

    removeSymbol(simbolo: string, token: any): Observable<any> {
        return this._sseservice.apiDelete('watchlist/symbols/' + simbolo, token);
    }
}
